function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC } from 'react';
import cn from 'classnames';
import { ILogoImageProps, LogoImageVariants, LogoImage } from './Image/Logo-Image';
import multilineTextLogoImageLight from './Logo.assets/logo-text-multiline_light.svg';
import multilineTextLogoImageDark from './Logo.assets/logo-text-multiline_dark.svg';
import oneLineTextLogoImageLight from './Logo.assets/logo-text-one-line_light.svg';
import oneLineTextLogoImageDark from './Logo.assets/logo-text-one-line_dark.svg';
import appIconLogoImage from './Logo.assets/logo-icon-app.svg';
import iconLogoImage from './Logo.assets/logo-icon.svg';
require("./Logo.css");
var styles = {
  "Root": "Logo-module-Root_1Qs"
};
const imageSourceMap = {
  [LogoImageVariants.default]: {
    light: multilineTextLogoImageLight,
    dark: multilineTextLogoImageDark
  },
  [LogoImageVariants.textOneLine]: {
    light: oneLineTextLogoImageLight,
    dark: oneLineTextLogoImageDark
  },
  [LogoImageVariants.iconApp]: {
    light: appIconLogoImage,
    dark: appIconLogoImage
  },
  [LogoImageVariants.icon]: {
    light: iconLogoImage,
    dark: iconLogoImage
  }
};
export const Logo = ({
  className,
  variant = LogoImageVariants.default,
  ...props
}) => /*#__PURE__*/React.createElement(LogoImage, _extends({
  sourceMap: imageSourceMap[variant],
  className: cn(styles.Root, styles[`${variant}Variant`], className)
}, props));
if (process.env.NODE_ENV !== 'production') {
  Logo.displayName = 'Logo';
}